import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2,
      // Keep cached data around long enough to be persisted to IndexedDB and
      // rehydrated when the app reopens offline.
      gcTime: 1000 * 60 * 60 * 24 * 7,
      retry: 1,
      networkMode: 'offlineFirst',
    },
    mutations: {
      networkMode: 'offlineFirst',
    },
  },
})
